const onChangeHandler = ({value, onChange}) => (selectedOption) => {
  const updatedValue = value.includes(selectedOption)
    ? [...value].filter((option) => option !== selectedOption)
    : [...value, selectedOption];
  onChange(updatedValue.join(','));
};

export default onChangeHandler;
